import React from 'react';
import { InfoModal, InfoModalProps } from '../../../../theme/components';
import CreateReportSchedule, {
  CreateReportScheduleProps,
} from './EditCreateReportSchedule';

function ModalEditCreateReportSchedule(
  props: InfoModalProps & CreateReportScheduleProps
) {
  return (
    <InfoModal {...props} maxWidth="md" fullWidth>
      <CreateReportSchedule {...props} />
    </InfoModal>
  );
}

export default ModalEditCreateReportSchedule;
